import React from "react";
import { IOption } from "./StoryBoard";

interface IProps {
    label: string;
    list: IOption[];
    value: IOption;
    rows: number;
    onChange: (name: string, value: string) => void;
    addItem?: (value: string) => void;
    className?: string;
}

function CustomSelectBox(props: IProps) {
    return (
        <div className={props.className}>
            <label htmlFor="selectInput">{props.label}</label>
            <div>
                <input
                    id="selectInput"
                    list="list"
                    value={props.value.name}
                    onChange={(ev: any) => props.onChange(ev.target.value, null)}
                />
                {props.addItem && <button 
                    onClick={() => props.addItem(props.value.name)}
                    disabled={!!props.list.find((i: IOption) => i.value === props.value.value)}
                >
                    Add
                </button>}
            </div>
            {props.rows === 0 && <datalist id="list">
                {props.list.map((e: IOption) => {return (<option key={"lst_" + e.value} value={e.name}/>)})}
            </datalist>}
            <select
                size={props.rows}
                value={props.value.value}
                onChange={(ev: any) => props.onChange(null, ev.target.value)}
            >
                {props.list.map((e: IOption) => {return (<option key={"opt_" + e.value} value={e.value}>{e.name}</option>)})}
            </select>
        </div>
    );
};
export default (CustomSelectBox);
